import "jquery";

window.modules = {
  ...window.modules,
  jquery: true,
};
